import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  SearchUpliftContractLinesQuery as SearchUpliftContractLines,
  SearchUpliftContractLinesQueryVariables
} from '@/graphql/contracts/_generated_/SearchUpliftContractLines.query';
import SearchUpliftContractLinesQuery from '@/graphql/contracts/SearchUpliftContractLines.query.gql';

import { UpliftSearchProps } from '@/pages/UpliftsManager/UpliftTool/components/UpliftToolSearch';
import { notificationService } from '@/services/notification/notification.client';

export function useSearchUplift() {

  const formatQueryInput = (criteria: UpliftSearchProps): SearchUpliftContractLinesQueryVariables => {
    const input: SearchUpliftContractLinesQueryVariables = {
      exemptFromUplift: criteria.includeExemptFromUplift,
      includeDirectDebits: criteria.includeDirectDebits
    };
    if (criteria.dateFrom) {
      input.nextBillingDateFrom = criteria.dateFrom;
    }
    if (criteria.dateTo) {
      input.nextBillingDateTo = criteria.dateTo;
    }
    if (criteria.searchString) {
      input.searchString = criteria.searchString;
    }
    if (criteria.contractID) {
      input.contractIds = [criteria.contractID];
    }
    if (criteria.customerID) {
      input.customerId = criteria.customerID;
    }
    return input;
  };

  const [_search, { loading, data }] = useLazyQuery<SearchUpliftContractLines, SearchUpliftContractLinesQueryVariables>(
    SearchUpliftContractLinesQuery,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      fetchPolicy: 'network-only'
    }
  );

  const getContractLines = (criteria: UpliftSearchProps) => {
    _search({
      variables: formatQueryInput(criteria)
    });
  };

  return {
    getContractLines: getContractLines,
    searchResults: data?.contractLinesByUpliftFilterByBillingCycles || [],
    loading
  };
}
